<div class="areas-bar">
  <div class="area-button-route" [ngClass]="{'current-route': selectedId === area.id}"
       *ngFor="let area of pricing?.areas; let i = index">
    <button mat-button (click)="switchArea(area)">
      <div class="space-block">
      </div>
      {{area.name}}
      <div class="space-block delete-button-block">
        <i class="pi pi-times" (click)="deleteArea($event, area, i)"></i>
      </div>
    </button>
  </div>

  <button mat-button class="area-plus-button" (click)="newArea()" [disabled]="newAreaLoading" *ngIf="!loadingSpinner">
    <i class="pi pi-plus" *ngIf="!newAreaLoading"></i>
    <lib-mini-progress-spinner *ngIf="newAreaLoading"></lib-mini-progress-spinner>
  </button>
</div>

<app-project-area-view *ngIf="chosenArea && !loadingSpinner" [area]="chosenArea" [pricingId]="pricing.id"
                       [boxGrades]="boxGrades" [matGrades]="matGrades"></app-project-area-view>
<lib-progress-spinner *ngIf="loadingSpinner"></lib-progress-spinner>
<div class="no-areas-block" *ngIf="this.pricing?.areas?.length === 0">
  <span>No Areas</span>
  <span>Please Add It Above</span>
</div>

<p-confirmDialog appendTo="body" icon="pi pi-trash" styleClass="item-panel">
</p-confirmDialog>
